import React from 'react';
import { useParams } from 'react-router-dom';
import AvailableData from './availableData/AvailableData';
import { availableDataTypes } from 'lib/constants';

export function VendorListDataTab() {
  const params = useParams();
  const tenantId = params.tenantId;
  const forecastId = params.forecastId;
  if (!tenantId || !forecastId)
    return <></>;

  return <AvailableData
    label="Vendor List"
    dataType={availableDataTypes.VendorList}
    tenantId={tenantId}
    forecastId={forecastId}
  />;
}

export default VendorListDataTab;